var map = {
	"./en/1/nav3.png": 31652,
	"./fi/1/nav3.png": 79426,
	"./in/1/nav3.png": 90304,
	"./th/1/nav3.png": 29295,
	"./tw/1/nav3.png": 86646,
	"./zh/1/nav3.png": 86829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70758;